
















import { defineComponent, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { getCookie, setCookie } from '../utils/cookies';
import { getRootDomain } from '../utils/rootDomain';
const { useState, useActions } = createNamespacedHelpers('loginStore');

export default defineComponent({
	props: {
		apiUrl: String,
		logoutUrl: String,
	},
	setup({ apiUrl, logoutUrl }) {
		const { isLoggedIn, sessionExpires, redirectToLogoutPage } = useState([
			'isLoggedIn',
			'sessionExpires',
			'redirectToLogoutPage',
		]);
		const { updateLoginState, updateSession } = useActions(['updateLoginState', 'updateSession']);
		const interval = 1000;
		let timer: ReturnType<typeof setInterval>;
		/**
		 * Logout, clearing the countdown, updating state and redirect to a given url
		 */
		function logout(url?: string) {
			clearInterval(timer);
			updateLoginState({
				isLoggedIn: false,
				sessionExpires: 0,
			});
			if (url && redirectToLogoutPage.value) {
				window.location.href = url;
			}
		}
		/**
		 * Get number of seconds from timestamp
		 */
		function getSeconds(time: string) {
			if (time === 'now') {
				return new Date().getTime() / 1000;
			}
			return new Date(time).getTime() / 1000;
		}
		/**
		 * Get the remaining time of the session in seconds
		 * formula: sessionLength - (now - sessionStartStamp)
		 */
		function getRemainingTime() {
			const sessionLength = getCookie('sessionLength');
			const sessionStartStamp = getCookie('sessionStartStamp');
			if (!sessionLength || !sessionStartStamp) {
				return 0;
			}
			return Math.ceil(parseInt(sessionLength) - (getSeconds('now') - getSeconds(sessionStartStamp)));
		}
		/**
		 * Reusable countdown fn for start/restarting the timer
		 */
		function countdown() {
			if (sessionExpires.value > 0) {
				updateLoginState({
					sessionExpires: getRemainingTime(),
					redirectToLogoutPage: true,
				});
			} else {
				logout(logoutUrl);
			}
		}
		function setTimer() {
			timer = setInterval(countdown, interval);
		}
		function extendSession() {
			clearInterval(timer);
			setCookie('sessionStartStamp', new Date().toString(), getRootDomain(window.location.host), '/');
			setCookie('isLoggedIn', 'true', getRootDomain(window.location.host), '/');
			updateSession(apiUrl);
			setTimer();
		}
		/**
		 * Extend session initially if logged in
		 */
		if (isLoggedIn.value) {
			extendSession();
		}
		/**
		 * Watch for logged-in state to start timer only when needed
		 */
		watch(isLoggedIn, () => {
			isLoggedIn.value && setTimer();
		});
		/**
		 * Show hint before session-expiration
		 */
		function showHint() {
			return sessionExpires.value > 0 && sessionExpires.value <= 20;
		}
		return {
			extendSession,
			showHint,
			logout,
			isLoggedIn,
			sessionExpires,
		};
	},
});
